import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "app/app.component";
import { appConfig } from "app/app.config";
import { ModuleRegistry as AgChartsModuleRegistry } from "ag-charts-community";
import {
  AllEnterpriseModule as AgChartsAllEnterpriseModule,
  LicenseManager as AgChartsLicenseManager,
} from "ag-charts-enterprise";
import { ModuleRegistry } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";
import { broadcastResponseToMainFrame } from "@azure/msal-browser/redirect-bridge";

const AG_LICENSE_KEY =
  "Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-102347}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TESVOLT_AG}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{3_August_2027}____[v3]_[0102]_MTgxNzI0NzYwMDAwMA==c9099904a2df878d5735807ba5e2c00b";

ModuleRegistry.registerModules([AllEnterpriseModule]);
AgChartsModuleRegistry.registerModules([AgChartsAllEnterpriseModule]);
LicenseManager.setLicenseKey(AG_LICENSE_KEY);
AgChartsLicenseManager.setLicenseKey(AG_LICENSE_KEY);

// Keep the already registered redirect URI (the application origin). Process
// MSAL 5 responses before Angular initializers, guards, or API calls can run.
// The bridge returns full-page redirects to their initiating URL and broadcasts
// popup/iframe responses to the main window. The next load consumes the cache.
const authHash = new URLSearchParams(window.location.hash.slice(1));
const authQuery = new URLSearchParams(window.location.search);
const isAuthenticationResponse = [authHash, authQuery].some(
  (params) => params.has("state") && (params.has("code") || params.has("error")),
);

if (isAuthenticationResponse) {
  broadcastResponseToMainFrame().catch((error) => {
    console.error("Authentication redirect processing failed", error);
  });
} else {
  bootstrapApplication(AppComponent, {
    ...appConfig,
    providers: [provideZoneChangeDetection(), ...appConfig.providers],
  }).catch((err) => console.error(err));
}
